export function createId(prefix = "id") {
    return `${prefix}_${crypto.randomUUID().slice(0, 8)}`;
}

export function createEmptyHint() {
    return {
        id: createId("hint"),
        text: "",
        code: "",
    };
}

export function createEmptyValidationRule() {
    return {
        id: createId("rule"),

        type: "missing_contains",

        value: "",

        feedback: [
            "",
        ],
    };
}

export function createEmptyProjectStep() {
    return {
        id: createId("step"),

        title: "",

        content: {
            before: [],
            instruction: [""],
            after: [],
        },

        editor: {
            language: "python",

            starterCode: "",

            prependCode: "",

            appendCode: "",
        },

        solution: {
            code: "",
        },

        validation: {
            type: "exact",

            value: "",

            rules: [],
        },

        feedback: {
            correct: [
                "",
            ],

            incorrect: [
                "",
            ],
        },

        hints: [
            createEmptyHint(),
        ],
    };
}